import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { type ComponentProps, type PropsWithChildren } from 'react';
import { CssBaseline } from '@lingoda/ui/theme';
import { IntlProvider } from '@lingoda/i18n';
import store from '../../redux';
import { StudentSnackbarProvider } from './StudentSnackbarProvider';
import { ThemeProvider } from './ThemeProvider';

interface ContextProvidersProps {
    locale: ComponentProps<typeof IntlProvider>['locale'];
}

export const ContextProviders = ({
    children,
    locale,
}: PropsWithChildren<ContextProvidersProps>) => (
    <Provider store={store}>
        <IntlProvider locale={locale}>
            <ThemeProvider>
                <CssBaseline />
                <StudentSnackbarProvider>
                    <HelmetProvider>{children}</HelmetProvider>
                </StudentSnackbarProvider>
            </ThemeProvider>
        </IntlProvider>
    </Provider>
);
